export function injectPrintStyles (html, fontSize = '11px') {
  return html.replace(
    /<\/head>/i,
    `<style>
      * {
        box-sizing: border-box;
        font-family: Arial, Helvetica, sans-serif;
      }

      body {
        margin: 0;
        padding: 0;
      }

      @media print {
        @page {
          size: A4;
          margin: 3mm;
        }
      }

      .certidao-habilitacao-root {
        width: 210mm;
        min-height: 297mm;
        margin: 0 auto;
        font-size: ${fontSize} !important;
        line-height: calc(${fontSize} * 1.3) !important;
      }

      .pagina-marginBack {
        padding: 0 10mm;
      }

      .conteudo-certidao {
        padding-top: 0 !important;
        width: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
      }

      .titulo {
        text-align: center;
        font-size: ${parseFloat(fontSize) * 2.545}px !important;
        font-weight: bold;
        text-transform: uppercase;
        margin: 40px 0;
      }

      .text-justify {
        text-align: justify;
      }

      .pt-10 {
        margin-top: 1em;
      }

      .f-11 { font-size: ${fontSize} !important; }
      .f-8  { font-size: calc(${fontSize} - 2px) !important; }

      .bloco-assinatura {
        margin-top: 40px;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 20px;
      }

      .col-esquerda,
      .col-direita {
        text-align: center;
        width: 45%;
      }

      .col-esquerda { margin-left: 15px; }
      .col-direita  { margin-right: 15px; }

      .bloco-selo {
        margin-top: 12px;
      }

      .img_selo {
        height: 180px;
        margin-top: 8px;
      }
    </style>
    </head>`
  )
}
